/**
 * 予約サイトの外にあるクリニック公式サイトのURL。
 *
 * 予約フローから外部へ送り出す導線が複数箇所（カード・モーダル等）にあるため、
 * URLの変更が一箇所で済むようにここへ集約する。
 */
export const ExternalSites = {
  /** 訪日・在留外国人向けの英語サイト（予約サイトからの流入を計測するためutmパラメータを付与） */
  EnglishLandingPage: 'https://clinicten.jp/en/?utm_source=reserve&utm_medium=link',
} as const;
